const DEBUG_MODE = true;

function debugLog(message, data = null) {
  if (!DEBUG_MODE) return;
  if (data) {
    console.log(`[CollectionFilters] ${message}`, data);
  } else {
    console.log(`[CollectionFilters] ${message}`);
  }
}

class CollectionFilters {
  constructor() {
    this.filterContainer = document.querySelector('[data-filter-container]');
    this.collectionsContainer = document.querySelector('[data-collections-grid]');
    this.clearButton = document.querySelector('[data-clear-filters]');
    this.resultsCount = document.querySelector('[data-results-count]');
    
    if (!this.filterContainer || !this.collectionsContainer) {
      console.warn('Collection filters: Required elements not found');
      return;
    }

    this.collections = [];
    this.activeFilters = {
      category: [],
      type_of_promotion: [],
      states: [],
      cities: [],
      locations: [],
      Keyword: [],
      promotions: null,
      within_x_kilometers: null
    };

    this.locationHierarchy = {};
    this.init();
  }

  init() {
    this.cacheCollections();
    this.buildLocationHierarchy();
    this.addEnhancements(); // ⭐ NUEVO: Agregar mejoras
    this.bindEvents();
    this.updateResultsCount();
    debugLog('CollectionFilters initialized');
    debugLog('Total collections cached:', this.collections.length);
    debugLog('Location hierarchy:', this.locationHierarchy);
  }

  // ============================================
  // ENHANCEMENTS - MEJORAS UX
  // ============================================
  
  addEnhancements() {
    this.addInternalSearches();
    this.addShowMoreButtons();
    this.addCountBadges();
    this.addSelectedPills();
  }

  addInternalSearches() {
    const filterGroups = this.filterContainer.querySelectorAll('[data-filter-group]');
    const THRESHOLD = 10; // Agregar búsqueda si hay 10+ opciones
    
    filterGroups.forEach(group => {
      const groupName = group.dataset.filterGroup;
      const optionsContainer = group.querySelector('.filter-options');
      const options = optionsContainer?.querySelectorAll('.filter-option');
      
      if (!options || options.length < THRESHOLD) return;
      
      // Crear input de búsqueda
      const searchWrapper = document.createElement('div');
      searchWrapper.className = 'filter-search-wrapper';
      searchWrapper.innerHTML = `
        <input 
          type="text" 
          class="filter-internal-search" 
          placeholder="🔍 Search ${groupName}..."
          data-search-for="${groupName}"
        >
      `;
      
      const content = group.querySelector('.filter-group-content');
      content.insertBefore(searchWrapper, optionsContainer);
      
      // Funcionalidad de búsqueda
      const searchInput = searchWrapper.querySelector('.filter-internal-search');
      searchInput.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        let visibleCount = 0;
        
        options.forEach(option => {
          const label = option.querySelector('.filter-label').textContent.toLowerCase();
          if (label.includes(searchTerm)) {
            option.style.display = '';
            visibleCount++;
          } else {
            option.style.display = 'none';
          }
        });
        
        // Mensaje "no results"
        let noResults = optionsContainer.querySelector('.filter-no-results');
        if (visibleCount === 0) {
          if (!noResults) {
            noResults = document.createElement('div');
            noResults.className = 'filter-no-results';
            noResults.textContent = 'No results found';
            optionsContainer.appendChild(noResults);
          }
          noResults.style.display = 'block';
        } else if (noResults) {
          noResults.style.display = 'none';
        }
      });
      
      debugLog(`Added search to ${groupName} filter (${options.length} options)`);
    });
  }

  addShowMoreButtons() {
    const filterGroups = this.filterContainer.querySelectorAll('[data-filter-group]');
    const INITIAL_SHOW = 10;
    
    filterGroups.forEach(group => {
      const optionsContainer = group.querySelector('.filter-options');
      const options = optionsContainer?.querySelectorAll('.filter-option');
      
      if (!options || options.length <= INITIAL_SHOW) return;
      
      // Ocultar extras
      optionsContainer.classList.add('collapsible');
      options.forEach((option, index) => {
        if (index >= INITIAL_SHOW) {
          option.classList.add('hidden-extra');
        }
      });
      
      // Botón
      const showMoreBtn = document.createElement('button');
      showMoreBtn.className = 'filter-show-more';
      showMoreBtn.type = 'button';
      const hiddenCount = options.length - INITIAL_SHOW;
      showMoreBtn.innerHTML = `
        + Show ${hiddenCount} more
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" style="margin-left:5px">
          <path d="M6 9L1 4h10z"/>
        </svg>
      `;
      
      const content = group.querySelector('.filter-group-content');
      content.appendChild(showMoreBtn);
      
      showMoreBtn.addEventListener('click', () => {
        const isExpanded = showMoreBtn.classList.contains('expanded');
        
        if (isExpanded) {
          options.forEach((option, index) => {
            if (index >= INITIAL_SHOW) option.classList.add('hidden-extra');
          });
          showMoreBtn.innerHTML = `+ Show ${hiddenCount} more <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" style="margin-left:5px"><path d="M6 9L1 4h10z"/></svg>`;
          showMoreBtn.classList.remove('expanded');
        } else {
          options.forEach(option => option.classList.remove('hidden-extra'));
          showMoreBtn.innerHTML = `− Show less <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor" style="margin-left:5px;transform:rotate(180deg)"><path d="M6 9L1 4h10z"/></svg>`;
          showMoreBtn.classList.add('expanded');
        }
      });
      
      debugLog(`Added "show more" to filter (${options.length} options)`);
    });
  }

  addCountBadges() {
    const filterHeaders = this.filterContainer.querySelectorAll('.filter-group-header');
    
    filterHeaders.forEach(header => {
      const group = header.closest('[data-filter-group]');
      const checkboxes = group.querySelectorAll('input[type="checkbox"]');
      
      if (checkboxes.length === 0) return;
      
      const badge = document.createElement('span');
      badge.className = 'filter-count-badge';
      badge.style.display = 'none';
      badge.textContent = '0';
      
      header.appendChild(badge);
      
      checkboxes.forEach(checkbox => {
        checkbox.addEventListener('change', () => {
          const checked = group.querySelectorAll('input[type="checkbox"]:checked');
          if (checked.length > 0) {
            badge.textContent = checked.length;
            badge.style.display = 'inline-flex';
          } else {
            badge.style.display = 'none';
          }
        });
      });
    });
  }

  addSelectedPills() {
    const pillsContainer = document.createElement('div');
    pillsContainer.className = 'selected-filters-pills';
    pillsContainer.style.display = 'none';
    
    const filtersHeader = this.filterContainer.querySelector('.filters-header');
    filtersHeader.after(pillsContainer);
    
    const updatePills = () => {
      const checked = this.filterContainer.querySelectorAll('input[type="checkbox"]:checked');
      
      if (checked.length === 0) {
        pillsContainer.style.display = 'none';
        pillsContainer.innerHTML = '';
        return;
      }
      
      pillsContainer.style.display = 'flex';
      pillsContainer.innerHTML = '';
      
      checked.forEach(checkbox => {
        const filterValue = checkbox.dataset.filterValue;
        
        const pill = document.createElement('div');
        pill.className = 'filter-pill';
        pill.innerHTML = `
          <span>${filterValue}</span>
          <button class="filter-pill-remove" type="button">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M2 2l10 10M12 2L2 12"/>
            </svg>
          </button>
        `;
        
        const removeBtn = pill.querySelector('.filter-pill-remove');
        removeBtn.addEventListener('click', () => {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        });
        
        pillsContainer.appendChild(pill);
      });
    };
    
    const checkboxes = this.filterContainer.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', updatePills);
    });
  }

  // ============================================
  // CORE FUNCTIONALITY
  // ============================================

  cacheCollections() {
    const collectionElements = this.collectionsContainer.querySelectorAll('[data-collection-item]');
    
    collectionElements.forEach(element => {
      let collectionTitle = '';
      const titleElement = element.querySelector('.collection-card-title');
      if (titleElement) {
        collectionTitle = titleElement.textContent.trim();
      }
      
      const statesRaw = element.dataset.metaState || '';
      const citiesRaw = element.dataset.metaCity || '';
      const locationsRaw = element.dataset.metaLocation || '';
      
      const collectionData = {
        element: element,
        title: collectionTitle,
        category: element.dataset.metaCategory || '',
        type_of_promotion: element.dataset.metaTypeOfPromotion || '',
        states: statesRaw ? statesRaw.split(',').map(s => s.trim()).filter(s => s !== '') : [],
        cities: citiesRaw ? citiesRaw.split(',').map(s => s.trim()).filter(s => s !== '') : [],
        locations: locationsRaw ? locationsRaw.split(',').map(s => s.trim()).filter(s => s !== '') : [],
        Keyword: element.dataset.metaKeyword || '',
        promotions: parseInt(element.dataset.metaPromotions) || 0,
        within_x_kilometers: parseInt(element.dataset.metaWithinXKilometers) || 0
      };
      
      this.collections.push(collectionData);
    });
  }

  buildLocationHierarchy() {
    this.collections.forEach(collection => {
      const { states, cities, locations } = collection;
      const maxLength = Math.max(states.length, cities.length, locations.length);
      
      for (let i = 0; i < maxLength; i++) {
        const state = states[i] || '';
        const city = cities[i] || '';
        const location = locations[i] || '';
        
        if (state) {
          if (!this.locationHierarchy[state]) {
            this.locationHierarchy[state] = {};
          }
          
          if (city) {
            if (!this.locationHierarchy[state][city]) {
              this.locationHierarchy[state][city] = [];
            }
            
            if (location && !this.locationHierarchy[state][city].includes(location)) {
              this.locationHierarchy[state][city].push(location);
            }
          }
        }
      }
    });
  }

  bindEvents() {
    const toggleButtons = this.filterContainer.querySelectorAll('[data-filter-toggle]');
    toggleButtons.forEach(button => {
      button.addEventListener('click', (e) => this.toggleFilterGroup(e));
    });

    const checkboxes = this.filterContainer.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => this.handleCheckboxChange(e));
    });

    const sliders = this.filterContainer.querySelectorAll('[data-filter-range]');
    sliders.forEach(slider => {
      slider.addEventListener('input', (e) => this.handleRangeChange(e));
    });

    if (this.clearButton) {
      this.clearButton.addEventListener('click', () => this.clearAllFilters());
    }

    const searchInput = this.filterContainer.querySelector('[data-filter-search]');
    if (searchInput) {
      searchInput.addEventListener('input', (e) => this.handleKeywordSearch(e));
    }
  }

  toggleFilterGroup(event) {
    const button = event.currentTarget;
    const content = button.nextElementSibling;
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    button.setAttribute('aria-expanded', !isExpanded);
    content.classList.toggle('active');
  }

  handleCheckboxChange(event) {
    const checkbox = event.target;
    const filterType = checkbox.dataset.filterType;
    const filterValue = checkbox.dataset.filterValue;

    if (filterType === 'state') {
      if (checkbox.checked) {
        if (!this.activeFilters.states.includes(filterValue)) {
          this.activeFilters.states.push(filterValue);
        }
      } else {
        this.activeFilters.states = this.activeFilters.states.filter(s => s !== filterValue);
      }
      this.updateCityOptions();
    } else if (filterType === 'city') {
      if (checkbox.checked) {
        if (!this.activeFilters.cities.includes(filterValue)) {
          this.activeFilters.cities.push(filterValue);
        }
      } else {
        this.activeFilters.cities = this.activeFilters.cities.filter(c => c !== filterValue);
      }
      this.updateLocationOptions();
    } else if (filterType === 'location') {
      if (checkbox.checked) {
        if (!this.activeFilters.locations.includes(filterValue)) {
          this.activeFilters.locations.push(filterValue);
        }
      } else {
        this.activeFilters.locations = this.activeFilters.locations.filter(l => l !== filterValue);
      }
    } else {
      // Other filters (category, type_of_promotion)
      if (checkbox.checked) {
        if (!this.activeFilters[filterType].includes(filterValue)) {
          this.activeFilters[filterType].push(filterValue);
        }
      } else {
        this.activeFilters[filterType] = this.activeFilters[filterType].filter(v => v !== filterValue);
      }
    }

    this.applyFilters();
    this.updateClearButton();
  }

  updateCityOptions() {
    const cityContainer = this.filterContainer.querySelector('[data-city-options]');
    if (!cityContainer) return;

    const cityCheckboxes = cityContainer.querySelectorAll('input[type="checkbox"]');
    
    if (this.activeFilters.states.length === 0) {
      cityCheckboxes.forEach(checkbox => {
        checkbox.closest('.filter-option').style.display = '';
        checkbox.disabled = false;
      });
      return;
    }

    const availableCities = new Set();
    this.activeFilters.states.forEach(state => {
      if (this.locationHierarchy[state]) {
        Object.keys(this.locationHierarchy[state]).forEach(city => {
          availableCities.add(city);
        });
      }
    });

    cityCheckboxes.forEach(checkbox => {
      const city = checkbox.dataset.filterValue;
      if (availableCities.has(city)) {
        checkbox.closest('.filter-option').style.display = '';
        checkbox.disabled = false;
      } else {
        checkbox.closest('.filter-option').style.display = 'none';
        checkbox.disabled = true;
        if (checkbox.checked) {
          checkbox.checked = false;
          this.activeFilters.cities = this.activeFilters.cities.filter(c => c !== city);
        }
      }
    });
  }

  updateLocationOptions() {
    const locationContainer = this.filterContainer.querySelector('[data-location-options]');
    if (!locationContainer) return;

    const locationCheckboxes = locationContainer.querySelectorAll('input[type="checkbox"]');
    
    if (this.activeFilters.states.length === 0 && this.activeFilters.cities.length === 0) {
      locationCheckboxes.forEach(checkbox => {
        checkbox.closest('.filter-option').style.display = '';
        checkbox.disabled = false;
      });
      return;
    }

    const availableLocations = new Set();
    
    if (this.activeFilters.cities.length > 0) {
      this.activeFilters.cities.forEach(city => {
        Object.keys(this.locationHierarchy).forEach(state => {
          if (this.locationHierarchy[state][city]) {
            this.locationHierarchy[state][city].forEach(loc => {
              availableLocations.add(loc);
            });
          }
        });
      });
    } else if (this.activeFilters.states.length > 0) {
      this.activeFilters.states.forEach(state => {
        if (this.locationHierarchy[state]) {
          Object.values(this.locationHierarchy[state]).forEach(locations => {
            locations.forEach(loc => availableLocations.add(loc));
          });
        }
      });
    }

    locationCheckboxes.forEach(checkbox => {
      const location = checkbox.dataset.filterValue;
      if (availableLocations.has(location)) {
        checkbox.closest('.filter-option').style.display = '';
        checkbox.disabled = false;
      } else {
        checkbox.closest('.filter-option').style.display = 'none';
        checkbox.disabled = true;
        if (checkbox.checked) {
          checkbox.checked = false;
          this.activeFilters.locations = this.activeFilters.locations.filter(l => l !== location);
        }
      }
    });
  }

  handleKeywordSearch(event) {
    const searchValue = event.target.value.trim().toLowerCase();
    this.activeFilters.Keyword = searchValue ? [searchValue] : [];
    this.applyFilters();
    this.updateClearButton();
  }

  handleRangeChange(event) {
    const slider = event.target;
    const filterType = slider.dataset.filterType;
    const value = parseInt(slider.value);

    this.activeFilters[filterType] = value;

    const display = slider.closest('.filter-range').querySelector('[data-range-display]');
    if (display) {
      if (filterType === 'within_x_kilometers') {
        display.textContent = `${value} km`;
      } else {
        display.textContent = value;
      }
    }

    this.applyFilters();
    this.updateClearButton();
  }

  applyFilters() {
    let visibleCount = 0;

    this.collections.forEach((collection) => {
      let isVisible = true;

      // Category Filter
      if (this.activeFilters.category.length > 0) {
        const collectionValue = (collection.category || '').trim();
        const collectionCategories = collectionValue.includes(',') 
          ? collectionValue.split(',').map(c => c.trim()).filter(c => c !== '')
          : (collectionValue !== '' ? [collectionValue] : []);
        
        const hasMatch = this.activeFilters.category.some(filterValue => 
          collectionCategories.some(cat => cat === filterValue.trim())
        );
        
        if (!hasMatch) isVisible = false;
      }

      // Type of Promotion Filter
      if (this.activeFilters.type_of_promotion.length > 0) {
        const collectionValue = (collection.type_of_promotion || '').trim();
        const hasMatch = this.activeFilters.type_of_promotion.some(filterValue => 
          collectionValue === filterValue.trim()
        );
        if (!hasMatch) isVisible = false;
      }

      // Location Filters
      if (this.activeFilters.states.length > 0 || 
          this.activeFilters.cities.length > 0 || 
          this.activeFilters.locations.length > 0) {
        
        let locationMatch = false;
        
        for (let i = 0; i < collection.states.length; i++) {
          const state = collection.states[i] || '';
          const city = collection.cities[i] || '';
          const location = collection.locations[i] || '';
          
          let stateMatch = true;
          let cityMatch = true;
          let locationMatch_inner = true;
          
          if (this.activeFilters.states.length > 0) {
            stateMatch = this.activeFilters.states.includes(state);
          }
          
          if (this.activeFilters.cities.length > 0) {
            cityMatch = this.activeFilters.cities.includes(city);
          }
          
          if (this.activeFilters.locations.length > 0) {
            locationMatch_inner = this.activeFilters.locations.includes(location);
          }
          
          if (stateMatch && cityMatch && locationMatch_inner) {
            locationMatch = true;
            break;
          }
        }
        
        if (!locationMatch) isVisible = false;
      }

      // Keyword Filter
      if (this.activeFilters.Keyword.length > 0) {
        const searchTerm = this.activeFilters.Keyword[0].toLowerCase();
        const collectionKeyword = (collection.Keyword || '').toLowerCase().trim();
        const collectionTitle = (collection.title || '').toLowerCase().trim();
        const hasMatch = collectionKeyword.includes(searchTerm) || collectionTitle.includes(searchTerm);
        if (!hasMatch) isVisible = false;
      }

      // Promotions Filter
      if (this.activeFilters.promotions !== null) {
        if (collection.promotions > this.activeFilters.promotions) isVisible = false;
      }

      // Distance Filter
      if (this.activeFilters.within_x_kilometers !== null) {
        if (collection.within_x_kilometers > this.activeFilters.within_x_kilometers) isVisible = false;
      }

      // Apply visibility
      if (isVisible) {
        collection.element.style.display = '';
        collection.element.classList.remove('hidden-by-filter');
        visibleCount++;
      } else {
        collection.element.style.display = 'none';
        collection.element.classList.add('hidden-by-filter');
      }
    });

    this.updateResultsCount(visibleCount);
  }

  updateResultsCount(count = null) {
    if (!this.resultsCount) return;
    const displayCount = count !== null ? count : this.collections.length;
    const total = this.collections.length;

    if (count === null || count === total) {
      this.resultsCount.textContent = `Showing ${total} collections`;
    } else {
      this.resultsCount.textContent = `Showing ${displayCount} of ${total} collections`;
    }
  }

  updateClearButton() {
    if (!this.clearButton) return;
    const hasActiveFilters = this.hasActiveFilters();
    this.clearButton.style.display = hasActiveFilters ? 'block' : 'none';
  }

  hasActiveFilters() {
    const arrayFilters = ['category', 'type_of_promotion', 'Keyword', 'states', 'cities', 'locations'];
    for (let filterType of arrayFilters) {
      if (this.activeFilters[filterType].length > 0) return true;
    }
    if (this.activeFilters.promotions !== null || this.activeFilters.within_x_kilometers !== null) {
      return true;
    }
    return false;
  }

  clearAllFilters() {
    this.activeFilters = {
      category: [],
      type_of_promotion: [],
      states: [],
      cities: [],
      locations: [],
      Keyword: [],
      promotions: null,
      within_x_kilometers: null
    };

    const checkboxes = this.filterContainer.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.checked = false;
      checkbox.disabled = false;
      checkbox.closest('.filter-option').style.display = '';
    });

    const searchInput = this.filterContainer.querySelector('[data-filter-search]');
    if (searchInput) searchInput.value = '';

    const internalSearches = this.filterContainer.querySelectorAll('.filter-internal-search');
    internalSearches.forEach(search => search.value = '');

    const sliders = this.filterContainer.querySelectorAll('[data-filter-range]');
    sliders.forEach(slider => {
      slider.value = slider.max;
      const display = slider.closest('.filter-range').querySelector('[data-range-display]');
      if (display) {
        const filterType = slider.dataset.filterType;
        if (filterType === 'within_x_kilometers') {
          display.textContent = `${slider.max} km`;
        } else {
          display.textContent = slider.max;
        }
      }
    });

    this.applyFilters();
    this.updateClearButton();
  }
}

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionFilters();
  });
} else {
  new CollectionFilters();
}
